import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Eye icon for preview/view functionality
 */
export const EyeIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </Icon>
  );
};

export default EyeIcon;
